export const STUDENTS_VIEW = 'students-view';
export const GROUP_VIEW = 'group-view';

export type NavigationView = typeof STUDENTS_VIEW | typeof GROUP_VIEW;
